import { createBrowserRouter, createRoutesFromElements, Route, useOutlet } from 'react-router-dom'
import Welcome from './pages/auth/Welcome'
import Login from './pages/auth/Login'
import SignUp from './pages/auth/SignUp'
import Activation from './pages/auth/Activation'
import SSOCallback from './pages/auth/SSOCallback'
import Dashboard from './pages/dashboard'
import StudentsList from './pages/dashboard/admin/studentsList'
import UserDashboardSetting from './pages/UserDashboard/settings/settings'
import UserAccountDetails from './pages/UserDashboard/settings/accountDetails'
import StripeCheckoutPage from './components/stripe/StripeCheckoutPage'
import PaymentSuccessPage from './components/stripe/PaymentSuccessPage'
import UserCourse from './pages/UserDashboard/course'
import { Instructions } from './pages/UserDashboard/instructions'
import { AuthProvider } from './hooks/useAuth'
import { ProtectedRoute } from './components/global/protectedRoute'
import { AuthContextProvider } from './contexts/AuthContext'
import { HomeLayout } from './components/global/HomeLayout'
import { Completed, UserDashboard } from './pages'
import ModuleReplay from './pages/UserDashboard/moduleReplay'
import Terms from './pages/auth/Terms'
import PasswordReset from './pages/auth/PasswordReset'
import AddStudents from './pages/dashboard/admin/addStudents'
import { KeyboardControlsProvider } from './contexts/KeyboardControlsContext'
import { BackgroundMusicProvider } from './contexts/BackgroundMusicContext'
import { NetworkErrorHandlerProvider } from './contexts/NetworkErrorContext'
import SSOProvider from './components/sso/SSOProvider'
import { UserPreferencesProvider } from './contexts/UserPreferencesContext'

const WrappedLayout = () => {
  const outlet = useOutlet()

  return (
    <SSOProvider>
      <AuthContextProvider>
        <AuthProvider>
          <UserPreferencesProvider>
            <KeyboardControlsProvider>
              <NetworkErrorHandlerProvider>
                <BackgroundMusicProvider>
                  {outlet}
                </BackgroundMusicProvider>
              </NetworkErrorHandlerProvider>
            </KeyboardControlsProvider>
          </UserPreferencesProvider>
        </AuthProvider>
      </AuthContextProvider>
    </SSOProvider>
  )
}

export default createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<WrappedLayout />}
    >
      <Route element={<HomeLayout />}>
        <Route path='/' element={<Welcome />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<SignUp />} />
        <Route path='/email/activation/:code' element={<Activation />} />
        <Route path='/auth/sso/callback' element={<SSOCallback />} />
        <Route path='/terms-of-use' element={<Terms />} />
        <Route path='/password-reset' element={<PasswordReset />} />
        <Route path='/checkout' element={<StripeCheckoutPage />} />
        <Route path='/payment-success' element={<PaymentSuccessPage />} />

      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path='/user-dashboard/setting' element={<UserDashboardSetting />}>
          <Route path='account-details' element={<UserAccountDetails />} />
        </Route>
        <Route path='/user-dashboard/instructions' element={<Instructions />} />
        <Route path='/user-dashboard/courses/:id' element={<UserCourse />} />
        <Route path='/user-dashboard/completed' element={<Completed />} />
        <Route path='/user-dashboard' element={<UserDashboard />} />
        <Route path='/dashboard' element={<Dashboard />}>
          <Route path='account-details' element={<UserAccountDetails />} />
          <Route path=':pageType' element={<StudentsList />} />
          <Route path='add-students' element={<AddStudents />} />
        </Route>
        <Route path='/user-dashboard/module-replay' element={<ModuleReplay />} />
      </Route>
    </Route>
  )
)
